import { Directive, AfterViewInit, EventEmitter, Output } from '@angular/core';

@Directive({
	selector: '[copoAfterViewInit]',
})
export class AfterViewInitDirective implements AfterViewInit {
	@Output() readonly afterviewinit = new EventEmitter<void>();
	ngAfterViewInit() {
		this.afterviewinit.emit();
	}
}
